import { render } from "./block-status-report-filter.vue?vue&type=template&id=451c3bf0&ts=true"
import script from "./block-status-report-filter.vue?vue&type=script&lang=ts"
export * from "./block-status-report-filter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__